<template>
  <div 
    class="tabs"
    ref="tabRef"
    v-loading="loading">
    <a 
      v-for="(item, index) in tabs"
      :key="index"
      :class="['item', {'active': active == index}]"
      @click="tabClick(index)">
      {{item.name}}
      <span v-show="item[numProp]">({{item[numProp]}})</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'default',
  data () {
    return {
      active: null,
      bgStyle: {}
    }
  },
  props: {
    tabs: {
      type: Array,
      required: false,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    numProp: {
      type: String,
      default: 'num'
    }
  },
  watch: {
    tabs: {
      handler(val){
        val && 
        val.length && 
        this.active == null && 
        this.$nextTick(() => this.tabClick(0));
      },
      immediate: true
    }
  },
  methods: {
    tabClick(index){
      if(this.active == index) 
        return;
      this.active = index;
      let tab = this.tabs[index];
      this.$emit('active', tab);
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs{
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  overflow-y: hidden;
  background-color: #FFF;
  margin: 1.05rem;
  padding: 0.525rem;
  min-height: 2.1rem;
  @extend .hide-scrollbar;

  .item{
    flex-shrink: 0;
    font-size: 1.1375rem;
    padding: .7rem 0.525rem;
    box-sizing: border-box;

    span{
      color: $text-red;
      transition: color .5s ease-out;
    }

    &.active{
      color: $theme-color;
      border-bottom: 0.175rem solid $theme-color;
    }

    &+.item{
      margin-left: 0.525rem;
    }
  }

  >>> .el-loading-spinner{
    transform: scale(.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tabs.vue